import React, { useState, useEffect, useRef } from "react"
import "./styles.scss";

export default props => {
  let [ load, setLoad ] = useState(false);
  let [ marks, setMarks ] = useState([]);
  let [ activeIndex, setActiveIndex ] = useState("");
  let [ changeProps, setChangeProps ] = useState(false);
  const [startPosition, setStartPosition] = useState(0);
  let ref = useRef();

  useEffect(() => {
    if(!load) {
      // const sliderEl4 = document.querySelector("#range4")

      // sliderEl4.addEventListener("input", (event) => {
      //   const tempSliderValue = event.target.value; 
        
      //   const progress = (tempSliderValue / sliderEl4.max) * 100;
      
      //   sliderEl4.style.background = `linear-gradient(to right, #f50 ${progress}%, #ccc ${progress}%)`;
      // })
      generateMarks();
      setLoad(true);
    }
  }, [load]);

  const generateMarks = () => {
    let newMarks = [];
    console.log(props)
    props.data && props.data.map((item, index) => { 
      if((props.minimum && item.replace('%', '') >= props.minimum) && (props.maximum && item.replace('%', '') <= props.maximum)) {
        newMarks = [...newMarks, item]  
      }
    })
    setMarks(newMarks);
  }

  function getClickPosition(e) {
    let clickX = e.offsetX;
    let marksHTML = document.getElementsByClassName('radio');
    let allPositionsMarks = [];
    for(let i = 0; i<marksHTML.length; i++) {
      let item = marksHTML[i];
      let itemWidth = item.offsetWidth;
      if(i == 0) {
        itemWidth = 0;
      } 
      let leftPositionItem = item.offsetLeft + itemWidth / 2;
      allPositionsMarks = [...allPositionsMarks, leftPositionItem];
    }
    for(let x = 0; x < allPositionsMarks.length; x++) {
      let currentMark = allPositionsMarks[x];
      let nextMark = allPositionsMarks[x + 1]
      if(nextMark) {
        if(clickX > currentMark && clickX < nextMark) {
          let left = clickX - currentMark;
          let right = nextMark - clickX;
          if(left < right) {
            props.setFunction(marks[x])
          }else{
            props.setFunction(marks[x + 1])
          }
        }
      }else{
        if(clickX > currentMark) {
          props.setFunction(marks[x])
        }
      }
    }
  }

  useEffect(() => {
    ref?.current?.addEventListener("mousedown", getClickPosition)

    return () => {
      ref?.current?.removeEventListener("mousedown", getClickPosition)
    }
  })

  return (
    <div class="range radio-range-slider">
      <div className="mask-clickable" ref={ref} />
      <div className="range-line" />
      <div class="sliderticks">
          {marks && marks.map((item, i) => (
            <span className={"radio " + (props.active === item ? 'active ' : '') + (props.gtmClass ? props.gtmClass : '')}>{ item }</span>
          ))}
        </div>
    </div>
  )
}
